import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../../core'
import * as subcategory from '../../subcategory'

// FIXME: - An issue occurs when executing 'createAttributeModel';
// specifically, 'dimensionId' fails to be set (likely due to its dependency
// on 'id'), resulting in other tables inheriting this attribute. Attributes
// lacking entityId and dimensionId are treated as 'universal'.
// NOTE: - The current workaround involves manually adding 'position' as an
// additional attribute to each entity within the dimension. attributes:
export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subcategory.RESOURCE.payload.dimension.partialId,
      partialId: subcategory.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Used for sorting in indirect cost rate proposals',
    isOptional: false,
    name: 'Sort Position',
    partialId: PartialId.Standard.create('position'),
    type: core.common.value.types.Intrinsic.Integer,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
